import { useState, useEffect, useCallback } from "react";
import { supabase } from "./supabase";

const DIETS = ["Veg","Non-Veg","Vegan","High Protein","Keto","Diabetic-friendly","Weight Loss"];
const DIET_ICONS = {"Veg":"🥦","Non-Veg":"🍗","Vegan":"🌱","High Protein":"💪","Keto":"🥑","Diabetic-friendly":"🩺","Weight Loss":"⚖️"};

const ini2 = (n) => (n||"?").split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase();
const esc  = (s) => String(s||"");

const S = {
  // Layout
  page:   { fontFamily:"'DM Sans','Segoe UI',sans-serif", background:"#F5F3EE", minHeight:"100vh", color:"#141A0F" },
  nav:    { position:"sticky", top:0, zIndex:100, background:"rgba(245,243,238,0.95)", backdropFilter:"blur(12px)", borderBottom:"1px solid #E8E4DC", padding:"0 1.25rem" },
  navIn:  { display:"flex", alignItems:"center", justifyContent:"space-between", height:58, maxWidth:1100, margin:"0 auto" },
  logo:   { fontFamily:"Georgia,serif", fontSize:"1.1rem", fontWeight:700, color:"#1A6B3C", letterSpacing:"-0.01em" },
  navBtn: { background:"#1A6B3C", color:"#fff", padding:"7px 16px", borderRadius:30, fontSize:"0.78rem", fontWeight:600, border:"none", cursor:"pointer" },
  hero:   { background:"linear-gradient(155deg,#0D3520 0%,#1A6B3C 55%,#2D8A52 100%)", padding:"3rem 1.25rem 2.5rem", textAlign:"center" },
  h1:     { fontFamily:"Georgia,serif", fontSize:"clamp(1.8rem,5vw,2.8rem)", fontWeight:700, color:"#fff", lineHeight:1.2, marginBottom:"0.8rem" },
  h1em:   { color:"#7ECDA0", fontStyle:"normal" },
  heroP:  { color:"rgba(255,255,255,0.72)", fontSize:"0.95rem", maxWidth:440, margin:"0 auto 1.75rem", fontWeight:300 },
  // Search
  sbox:   { background:"#fff", borderRadius:20, padding:"0.9rem", display:"flex", flexDirection:"column", gap:8, maxWidth:500, margin:"0 auto", boxShadow:"0 8px 40px rgba(20,26,15,0.18)" },
  sinp:   { flex:1, border:"1.5px solid #E8E4DC", borderRadius:10, padding:"10px 12px", fontSize:"0.88rem", outline:"none", fontFamily:"inherit", minWidth:0 },
  ssel:   { border:"1.5px solid #E8E4DC", borderRadius:10, padding:"10px 12px", fontSize:"0.85rem", fontFamily:"inherit", background:"#fff", outline:"none", cursor:"pointer" },
  sbtn:   { background:"#1A6B3C", color:"#fff", border:"none", borderRadius:10, padding:"10px 18px", fontSize:"0.88rem", fontWeight:600, cursor:"pointer", fontFamily:"inherit" },
  // Chips
  chipWrap:{ overflowX:"auto", WebkitOverflowScrolling:"touch", padding:"1.25rem 0", scrollbarWidth:"none" },
  chipRow: { display:"flex", gap:8, padding:"2px 1.25rem", width:"max-content", margin:"0 auto" },
  // Cards
  wrap:   { maxWidth:1100, margin:"0 auto", padding:"0 1.25rem" },
  grid:   { display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))", gap:14 },
  card:   { background:"#fff", borderRadius:16, overflow:"hidden", boxShadow:"0 2px 16px rgba(20,26,15,0.08)", cursor:"pointer", transition:"transform 0.18s,box-shadow 0.18s" },
  cardH:  { height:88, display:"flex", alignItems:"flex-end", padding:10, position:"relative" },
  logo2:  { width:48, height:48, borderRadius:13, background:"#fff", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"Georgia,serif", fontSize:"1.2rem", fontWeight:700, boxShadow:"0 2px 8px rgba(0,0,0,0.14)", flexShrink:0 },
  cardB:  { padding:12 },
  cname:  { fontWeight:600, fontSize:"0.95rem", color:"#141A0F", marginBottom:2 },
  ctag:   { fontSize:"0.8rem", color:"#6B7A60", marginBottom:8, display:"-webkit-box", WebkitLineClamp:2, WebkitBoxOrient:"vertical", overflow:"hidden", lineHeight:1.4 },
  tags:   { display:"flex", flexWrap:"wrap", gap:4, marginBottom:8 },
  tag:    { background:"#E8F5ED", color:"#1A6B3C", fontSize:"0.68rem", fontWeight:500, padding:"2px 8px", borderRadius:20 },
  cfoot:  { display:"flex", alignItems:"center", justifyContent:"space-between", paddingTop:8, borderTop:"1px solid #F5F3EE", gap:6 },
  rat:    { display:"flex", alignItems:"center", gap:3, fontSize:"0.78rem", color:"#3D4A35", fontWeight:500 },
  area:   { fontSize:"0.7rem", color:"#6B7A60", flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" },
  planBtn:{ background:"#E8F5ED", color:"#1A6B3C", border:"none", borderRadius:20, padding:"4px 10px", fontSize:"0.73rem", fontWeight:600, cursor:"pointer", fontFamily:"inherit" },
  menuBtn:{ background:"#FEF3DC", color:"#C8860A", border:"none", borderRadius:20, padding:"4px 10px", fontSize:"0.73rem", fontWeight:600, cursor:"pointer", fontFamily:"inherit" },
  // Modal
  ovl:    { position:"fixed", inset:0, background:"rgba(20,26,15,0.55)", zIndex:200, display:"flex", alignItems:"flex-end", justifyContent:"center" },
  sheet:  { background:"#fff", borderRadius:"22px 22px 0 0", width:"100%", maxWidth:560, maxHeight:"88vh", overflowY:"auto", WebkitOverflowScrolling:"touch" },
  drag:   { width:36, height:4, background:"#E8E4DC", borderRadius:2, margin:"10px auto 0" },
  mHero:  { height:120, display:"flex", alignItems:"flex-end", padding:14, position:"relative" },
  mClose: { position:"absolute", top:12, right:12, width:28, height:28, borderRadius:"50%", background:"rgba(255,255,255,0.85)", border:"none", cursor:"pointer", fontSize:"0.9rem", display:"flex", alignItems:"center", justifyContent:"center" },
  mName:  { fontFamily:"Georgia,serif", fontSize:"1.25rem", fontWeight:700, color:"#141A0F", marginTop:10, marginBottom:2 },
  mOwn:   { fontSize:"0.78rem", color:"#6B7A60", marginBottom:10 },
  mtabs:  { display:"flex", gap:0, borderBottom:"2px solid #E8E4DC", margin:"12px 0 0" },
  mtab:   { padding:"8px 16px", fontSize:"0.8rem", fontWeight:500, color:"#6B7A60", border:"none", background:"none", borderBottom:"2px solid transparent", marginBottom:-2, cursor:"pointer", fontFamily:"inherit" },
  mst:    { fontSize:"0.68rem", fontWeight:600, color:"#6B7A60", textTransform:"uppercase", letterSpacing:"0.06em", margin:"14px 0 7px" },
  pr:     { display:"flex", alignItems:"center", justifyContent:"space-between", padding:"9px 0", borderBottom:"1px solid #F5F3EE" },
  pn:     { fontWeight:500, fontSize:"0.84rem", color:"#141A0F" },
  pd:     { fontSize:"0.72rem", color:"#6B7A60", marginTop:1 },
  pp:     { fontWeight:700, fontSize:"0.94rem", color:"#1A6B3C" },
  at:     { background:"#F5F3EE", color:"#3D4A35", fontSize:"0.72rem", padding:"3px 9px", borderRadius:20, fontWeight:500 },
  waBtn:  { display:"flex", alignItems:"center", justifyContent:"center", gap:8, width:"100%", background:"#25D366", color:"#fff", border:"none", borderRadius:14, padding:13, fontSize:"0.92rem", fontWeight:600, marginTop:"1rem", cursor:"pointer", fontFamily:"inherit" },
  mimg:   { width:"100%", aspectRatio:"4/3", objectFit:"cover", borderRadius:10, background:"#F5F3EE", display:"block" },
  // Sections
  howSec: { background:"#1A6B3C", padding:"2rem 1.25rem", margin:"1rem 0" },
  steps:  { display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:12, maxWidth:1100, margin:"0 auto" },
  step:   { background:"rgba(255,255,255,0.1)", borderRadius:14, padding:"1rem", textAlign:"center" },
  snum:   { width:32, height:32, borderRadius:"50%", background:"rgba(255,255,255,0.2)", color:"#fff", fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 8px" },
  dgrid:  { display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10 },
  dtile:  { background:"#fff", borderRadius:14, padding:"0.9rem", textAlign:"center", cursor:"pointer", boxShadow:"0 2px 12px rgba(20,26,15,0.07)" },
  footer: { background:"#141A0F", padding:"2rem 1.25rem 3rem" },
  fWrap:  { maxWidth:1100, margin:"0 auto" },
  fBot:   { marginTop:"1.5rem", paddingTop:"0.8rem", borderTop:"1px solid rgba(255,255,255,0.07)", fontSize:"0.7rem", color:"rgba(255,255,255,0.28)", textAlign:"center" },
};

export default function LandingPage() {
  const [providers,    setProviders]    = useState([]);
  const [loading,      setLoading]      = useState(true);
  const [searchCity,   setSearchCity]   = useState("");
  const [activeDiet,   setActiveDiet]   = useState("");
  const [filtered,     setFiltered]     = useState([]);
  const [modal,        setModal]        = useState(null);
  const [modalTab,     setModalTab]     = useState("plans");

  // Fetch from Supabase using the existing client
  useEffect(() => {
    const fetch = async () => {
      try {
        const { data, error } = await supabase
          .from("mealbox_users")
          .select("id,name,owner,city,tagline,description,whatsapp,areas_served,diet_types,meal_types,plans,color,rating,review_count,menu_images")
          .eq("is_listed", true)
          .eq("active", true)
          .neq("id", "superadmin")
          .order("name");
        if (error) throw error;
        setProviders(data || []);
        setFiltered(data || []);
      } catch(e) {
        console.error("LandingPage fetch error:", e.message);
      }
      setLoading(false);
    };
    fetch();
    // Poll every 30s for live updates
    const t = setInterval(fetch, 30000);
    return () => clearInterval(t);
  }, []);

  const applyFilters = useCallback((city, diet, list) => {
    let res = [...list];
    const q = city.toLowerCase().trim();
    if (q) res = res.filter(p =>
      (p.areas_served||[]).some(a=>a.toLowerCase().includes(q)) ||
      (p.city||"").toLowerCase().includes(q)
    );
    if (diet) res = res.filter(p=>(p.diet_types||[]).includes(diet));
    setFiltered(res);
  }, []);

  const setDiet = (d) => { setActiveDiet(d); applyFilters(searchCity, d, providers); };
  const search  = ()  => { applyFilters(searchCity, activeDiet, providers); };

  const openModal = (p, tab="plans") => { setModal(p); setModalTab(tab); document.body.style.overflow="hidden"; };
  const closeModal = ()               => { setModal(null); document.body.style.overflow=""; };

  const chip = (diet) => (
    <button key={diet||"all"} onClick={()=>setDiet(diet)}
      style={{ display:"flex", alignItems:"center", gap:6, background: activeDiet===diet?"#1A6B3C":"#fff", border:`1.5px solid ${activeDiet===diet?"#1A6B3C":"#E8E4DC"}`, borderRadius:30, padding:"6px 14px", fontSize:"0.78rem", fontWeight:500, color:activeDiet===diet?"#fff":"#3D4A35", cursor:"pointer", whiteSpace:"nowrap", fontFamily:"inherit" }}>
      {diet ? <>{DIET_ICONS[diet]||"◈"} {diet}</> : <>🍽 All</>}
    </button>
  );

  return (
    <div style={S.page}>

      {/* NAV */}
      <nav style={S.nav}>
        <div style={S.navIn}>
          <span style={S.logo}>DietFoodDelivery<span style={{color:"#C8860A"}}>.in</span></span>
          <a href="https://app.dietfooddelivery.in" style={{...S.navBtn, textDecoration:"none"}}>Provider Login</a>
        </div>
      </nav>

      {/* HERO */}
      <section style={S.hero}>
        <div style={{maxWidth:1100, margin:"0 auto"}}>
          <div style={{display:"inline-flex",alignItems:"center",gap:6,background:"rgba(255,255,255,0.12)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:30,padding:"4px 14px",fontSize:"0.72rem",color:"rgba(255,255,255,0.85)",marginBottom:"1rem",letterSpacing:"0.05em",textTransform:"uppercase"}}>
            🥗 Fresh · Healthy · Delivered Daily
          </div>
          <h1 style={S.h1}>Find Your Perfect<br/><em style={S.h1em}>Diet Meal Plan</em></h1>
          <p style={S.heroP}>Discover local meal services tailored for your dietary goals.</p>

          <div style={S.sbox}>
            <div style={{display:"flex", gap:7}}>
              <input style={S.sinp} value={searchCity} onChange={e=>setSearchCity(e.target.value)}
                onKeyDown={e=>e.key==="Enter"&&search()}
                placeholder="Your city e.g. Chennai…"/>
              <select style={S.ssel} value={activeDiet} onChange={e=>setDiet(e.target.value)}>
                <option value="">All diets</option>
                {DIETS.map(d=><option key={d} value={d}>{d}</option>)}
              </select>
            </div>
            <button style={S.sbtn} onClick={search}>Search Providers →</button>
          </div>
        </div>
      </section>

      {/* CATEGORY CHIPS */}
      <div style={S.chipWrap}>
        <div style={S.chipRow}>
          {chip("")}
          {DIETS.map(d=>chip(d))}
        </div>
      </div>

      {/* PROVIDERS */}
      <div style={S.wrap}>
        <div style={{display:"flex",alignItems:"baseline",justifyContent:"space-between",margin:"1.5rem 0 1rem"}}>
          <h2 style={{fontFamily:"Georgia,serif",fontSize:"1.3rem",fontWeight:700,color:"#141A0F"}}>
            {activeDiet && searchCity ? `${activeDiet} in ${searchCity}` : activeDiet || (searchCity ? `Providers in ${searchCity}` : "All Providers")}
          </h2>
          <span style={{fontSize:"0.8rem",color:"#6B7A60"}}>{filtered.length > 0 ? `${filtered.length} provider${filtered.length>1?"s":""}` : ""}</span>
        </div>

        {loading ? (
          <div style={{...S.grid}}>
            {[1,2,3].map(i=>(
              <div key={i} style={{height:210,borderRadius:16,background:"linear-gradient(90deg,#eee 25%,#f5f5f5 50%,#eee 75%)",backgroundSize:"200% 100%",animation:"shimmer 1.4s infinite"}}/>
            ))}
          </div>
        ) : filtered.length === 0 ? (
          <div style={{textAlign:"center",padding:"3rem",color:"#6B7A60",fontSize:"0.9rem"}}>
            <div style={{fontSize:"2rem",marginBottom:10}}>🔍</div>
            <p>No providers found. Try a different city or diet type.</p>
          </div>
        ) : (
          <div style={S.grid}>
            {filtered.map((p,i) => {
              const bg  = p.color||"#1A6B3C";
              const ar  = (p.areas_served||[])[0]||p.city||"";
              const tgs = (p.diet_types||[]).slice(0,3);
              const hasMenu = (p.menu_images||[]).length > 0;
              return (
                <div key={p.id} style={S.card}
                  onClick={()=>openModal(p,"plans")}
                  onMouseOver={e=>{e.currentTarget.style.transform="translateY(-3px)";e.currentTarget.style.boxShadow="0 8px 32px rgba(20,26,15,0.14)";}}
                  onMouseOut={e=>{e.currentTarget.style.transform="";e.currentTarget.style.boxShadow="0 2px 16px rgba(20,26,15,0.08)";}}>
                  <div style={{...S.cardH, background:`linear-gradient(135deg,${bg}dd,${bg}77)`}}>
                    <div style={{...S.logo2, color:bg}}>{ini2(p.name)}</div>
                    <div style={{position:"absolute",top:8,right:8,background:"rgba(255,255,255,0.9)",borderRadius:20,padding:"2px 9px",fontSize:"0.68rem",fontWeight:600,color:"#1A6B3C"}}>Open</div>
                  </div>
                  <div style={S.cardB}>
                    <div style={S.cname}>{esc(p.name)}</div>
                    <div style={S.ctag}>{esc(p.tagline||"Fresh healthy meals delivered daily")}</div>
                    <div style={S.tags}>{tgs.map(d=><span key={d} style={S.tag}>{d}</span>)}</div>
                    <div style={S.cfoot}>
                      <div style={S.rat}><span style={{color:"#C8860A"}}>★</span>{p.rating||4.5}<span style={{color:"#6B7A60",fontWeight:400}}> ({p.review_count||0})</span></div>
                      <div style={S.area}>📍 {esc(ar)}</div>
                      <div style={{display:"flex",gap:4}}>
                        {hasMenu && <button style={S.menuBtn} onClick={e=>{e.stopPropagation();openModal(p,"menu");}}>Menu</button>}
                        <button style={S.planBtn} onClick={e=>{e.stopPropagation();openModal(p,"plans");}}>Plans</button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* HOW IT WORKS */}
      <section style={{...S.howSec, marginTop:"2rem"}}>
        <h2 style={{fontFamily:"Georgia,serif",fontSize:"1.3rem",fontWeight:700,color:"#fff",textAlign:"center",marginBottom:"1.25rem"}}>How It Works</h2>
        <div style={S.steps}>
          {[["1","Search Your City","Enter your city and diet preference to find providers near you"],
            ["2","Pick Your Plan","Compare menus and pricing — choose what fits your goals"],
            ["3","Get Delivered Daily","Fresh meals every morning to your door or workplace"]
          ].map(([n,t,d])=>(
            <div key={n} style={S.step}>
              <div style={S.snum}>{n}</div>
              <div style={{fontSize:"0.86rem",fontWeight:600,color:"#fff",marginBottom:4}}>{t}</div>
              <div style={{fontSize:"0.75rem",color:"rgba(255,255,255,0.68)",lineHeight:1.5}}>{d}</div>
            </div>
          ))}
        </div>
      </section>

      {/* BROWSE BY GOAL */}
      <div style={{...S.wrap, padding:"1.5rem 1.25rem"}}>
        <h2 style={{fontFamily:"Georgia,serif",fontSize:"1.3rem",fontWeight:700,color:"#141A0F",marginBottom:"1rem"}}>Browse by Health Goal</h2>
        <div style={S.dgrid}>
          {[["🥦","Pure Vegetarian","Balanced veg","Veg"],["🌱","Vegan","100% plant-based","Vegan"],
            ["💪","High Protein","For fitness goals","High Protein"],["🥑","Keto","Fat-burning diet","Keto"],
            ["🩺","Diabetic-friendly","Low GI controlled","Diabetic-friendly"],["⚖️","Weight Loss","Calorie-conscious","Weight Loss"]
          ].map(([em,t,d,diet])=>(
            <div key={diet} style={S.dtile} onClick={()=>setDiet(diet)}
              onMouseOver={e=>e.currentTarget.style.transform="scale(0.98)"}
              onMouseOut={e=>e.currentTarget.style.transform=""}>
              <div style={{fontSize:"1.6rem",marginBottom:5}}>{em}</div>
              <div style={{fontSize:"0.8rem",fontWeight:600,color:"#141A0F",marginBottom:2}}>{t}</div>
              <div style={{fontSize:"0.68rem",color:"#6B7A60"}}>{d}</div>
            </div>
          ))}
        </div>
      </div>

      {/* FOOTER */}
      <footer style={S.footer}>
        <div style={S.fWrap}>
          <div style={{fontFamily:"Georgia,serif",fontSize:"1.2rem",fontWeight:700,color:"#fff",marginBottom:6}}>
            DietFoodDelivery<span style={{color:"#7ECDA0"}}>.in</span>
          </div>
          <div style={{fontSize:"0.78rem",color:"rgba(255,255,255,0.4)",lineHeight:1.6,maxWidth:400}}>
            Connecting health-conscious people with the best local diet meal delivery services across Tamil Nadu.
          </div>
          <div style={S.fBot}>© 2026 DietFoodDelivery.in · Healthy Tamil Nadu 🥗</div>
        </div>
      </footer>

      {/* PROVIDER MODAL */}
      {modal && (
        <div style={S.ovl} onClick={e=>e.target===e.currentTarget&&closeModal()}>
          <div style={S.sheet}>
            <div style={S.drag}/>
            <div style={{...S.mHero, background:`linear-gradient(135deg,${modal.color||"#1A6B3C"}dd,${modal.color||"#1A6B3C"}77)`}}>
              <button style={S.mClose} onClick={closeModal}>✕</button>
              <div style={{...S.logo2, color:modal.color||"#1A6B3C", width:56, height:56, fontSize:"1.4rem"}}>{ini2(modal.name)}</div>
            </div>
            <div style={{padding:"0 1.2rem 1.5rem"}}>
              <div style={S.mName}>{esc(modal.name)}</div>
              <div style={S.mOwn}>{modal.owner?`by ${modal.owner} · ${modal.city||""}`:modal.city||""}</div>
              <div style={S.tags}>
                {(modal.diet_types||[]).map(d=><span key={d} style={S.tag}>{d}</span>)}
                {(modal.meal_types||[]).map(m=><span key={m} style={{...S.tag,background:"#FEF3DC",color:"#C8860A"}}>{m}</span>)}
              </div>

              {/* Tabs */}
              <div style={S.mtabs}>
                {[["plans","Plans & Pricing"],["menu","View Menu"],["about","About"]].map(([k,l])=>(
                  <button key={k} style={{...S.mtab, color:modalTab===k?"#1A6B3C":"#6B7A60", borderBottomColor:modalTab===k?"#1A6B3C":"transparent"}}
                    onClick={()=>setModalTab(k)}>{l}</button>
                ))}
              </div>

              {/* Plans */}
              {modalTab==="plans" && <>
                <div style={S.mst}>Meal Plans</div>
                {(modal.plans||[]).length ? (modal.plans).map((pl,i)=>(
                  <div key={i} style={{...S.pr, borderBottom:i<(modal.plans.length-1)?"1px solid #F5F3EE":"none"}}>
                    <div><div style={S.pn}>{esc(pl.name)}</div><div style={S.pd}>{esc(pl.desc)}</div></div>
                    <div style={S.pp}>{esc(pl.price)}</div>
                  </div>
                )) : <p style={{fontSize:"0.82rem",color:"#6B7A60"}}>Contact for pricing</p>}
                <div style={S.mst}>Delivery Areas</div>
                <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                  {(modal.areas_served||[]).map(a=><span key={a} style={S.at}>📍 {a}</span>)}
                  {!(modal.areas_served||[]).length && <span style={{fontSize:"0.8rem",color:"#6B7A60"}}>Contact for areas</span>}
                </div>
              </>}

              {/* Menu */}
              {modalTab==="menu" && <>
                <div style={S.mst}>Menu Photos</div>
                {(modal.menu_images||[]).length ? (
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                    {modal.menu_images.map((url,i)=><img key={i} src={url} alt={`Menu ${i+1}`} style={S.mimg} loading="lazy"/>)}
                  </div>
                ) : <div style={{padding:"1.5rem",textAlign:"center",color:"#6B7A60",fontSize:"0.82rem",background:"#F5F3EE",borderRadius:10}}>📷 Menu photos coming soon</div>}
              </>}

              {/* About */}
              {modalTab==="about" && <>
                <div style={S.mst}>About</div>
                <p style={{fontSize:"0.85rem",color:"#3D4A35",lineHeight:1.65}}>{esc(modal.description||modal.tagline||"")}</p>
                <div style={S.mst}>Meal Slots</div>
                <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                  {(modal.meal_types||[]).map(m=><span key={m} style={S.at}>{m}</span>)}
                </div>
              </>}

              {modal.whatsapp && (
                <button style={S.waBtn} onClick={()=>{
                  const ph  = modal.whatsapp.replace(/\D/g,"");
                  const msg = encodeURIComponent(`Hi! I found ${modal.name} on DietFoodDelivery.in and I'm interested in your meal plans. Could you share more details?`);
                  window.open(`https://wa.me/${ph}?text=${msg}`,"_blank");
                }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                  Chat on WhatsApp
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}`}</style>
    </div>
  );
}
